__turbopack_context__.v({
  "heroBottomFade": "home-shared-module__rcV5GW__heroBottomFade",
  "homeHeroBottomFadeIn": "home-shared-module__rcV5GW__homeHeroBottomFadeIn",
  "tileCard": "home-shared-module__rcV5GW__tileCard",
  "tileCardStatic": "home-shared-module__rcV5GW__tileCardStatic",
  "tileCardVisible": "home-shared-module__rcV5GW__tileCardVisible",
  "tileImage": "home-shared-module__rcV5GW__tileImage",
  "tileLabel": "home-shared-module__rcV5GW__tileLabel",
  "tileReveal": "home-shared-module__rcV5GW__tileReveal",
});
